export var flowRange = [
    { lower: 100, upper: 999, casingScreenDiameter: 16 },
    { lower: 1000, upper: 1999, casingScreenDiameter: 18 },
    { lower: 2000, upper: 5000, casingScreenDiameter: 20 },
];
